export default {
  changeSearchHandler({ state, commit }, search) {
    if (!search) {
      const patientsList = state.originalTableData.reduce((acc, val) => {
        return acc.concat(val.patient);
      }, []);
      commit("setpatientsTableDataForSafe", patientsList);
      commit("setpatientsTableDataForProvider", patientsList);
      return;
    }
    let patients = [];
    state.originalTableData.forEach((provider) => {
      const data = provider.patient.filter((patient) => {
        if (patient.hasOwnProperty('aid'))
          return patient.aid.toLowerCase().includes(search.toLowerCase())
        else
          return patient.name.toLowerCase().includes(search.toLowerCase())
      });
      patients = [...patients, ...data];
    });
    commit("setpatientsTableDataForSafe", patients);
    commit("setpatientsTableDataForProvider", patients);
  },
  changePatientTag({ state, commit }, tagValue) {
    let patients = [];
    state.originalTableData.forEach((provider) => {
      const data = provider.patient.filter((patient) => {
        const isPresent = patient.tag
          ? patient.tag.filter((ele) => ele.id === tagValue)
          : [];
        return isPresent.length > 0;
      });
      patients = [...patients, ...data];
    });
    commit("setpatientsTableDataForSafe", patients);
    commit("setpatientsTableDataForProvider", patients);
  },
  handleProcedureDateSorting({ state, commit }, type) {},
  handleNextEventSorting({ state, commit }, type) {},
};
